<template>
  <div class="ingresarView">
    <header-component
      title="
      Ingresar o Registrarse
      "
      map="false"
    />
    <div class="container p-b-50">
      <div class="columns is-centered">
        <div class="column is-half">
          <h2 class="h2Title">Ingresar</h2>
          <div class="columns">
            <div class="column">

             
              <form autocomplete="on">
                <b-field label="Correo">
                  <b-input
                    type="text"
                    placeholder="Correo"
                    name="email"
                    v-model="email"
                  ></b-input>
                </b-field>
                <b-field label="Clave secreta">
                  <b-input
                    name="password"
                    type="password"
                    placeholder="Contraseña"
                    password-reveal
                    v-model="password"
                  ></b-input>
                </b-field>
                {{ info }}
                        <p class="subtitle is-6 has-text-info"> Si no tiene una cuenta creada por favor use el botón de Registrarme</p>
                <b-button type="is-primary" @click="login" :loading="lingresar">Ingresar</b-button>
                <b-button type="is-info" @click="isComponentModalActive = true"
                  >Registrarme</b-button
                >
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :active.sync="isComponentModalActive"
      has-modal-card
      trap-focus
      aria-role="dialog"
      aria-modal
    >
      <register-component v-on:correctRegister="ingresar"/>
    </b-modal>
  </div>
</template>

<script>
import RegisterComponent from "@/components/RegisterComponent.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
export default {
  components: {
    HeaderComponent,
    RegisterComponent,
  },
  methods: {
    ingresar(){
      this.$router.push("/usuario");
    },
    login() {
      this.lingresar=true;
      const form = new FormData();
      if(! this.email.includes("@")){
        this.email=this.email+"@notariavilca.org";
      }
      form.append("email", this.email);
      form.append("password", this.password);
      this.$http
        .post(this.$store.state.url + "/api/login", form)
        .then((response) => {
          this.$store.dispatch("setUser", response.data.success).then(() => {
            this.lingresar=false;
            this.$router.push("/usuario");
          });
        })
        .catch((error) => {
          this.lingresar=false;
          if (error.response.status == 401) {
            this.$buefy.dialog.alert({
              title: "Hubo un error en la conexión",
              message: "Las credenciales son incorrectas.",
              type: "is-warning",
              hasIcon: true,
              icon:"alert-octagon"
            });
          }else{
            alert("Error al ingresar");
          }
        });
    },
  },
  mounted() {
    if(this.$store.state.login){
      this.$router.push("/usuario");
    }
  },
  data() {
    return {
      lingresar:false,
      imgHome: process.env.MIX_APP_URL + "img/notariaVilca.jpg",
      cuerpoDocumento:
        "El contenido del documento aparecera aqui. Recuerde que solo tiene 3 consultas por dia.",
      dni: "",
      info: "",
      codigo: "",
      email: "",
      password: "",
      isComponentModalActive: false
    };
  },
};
</script>
<style lang="scss">
.ingresarView {
  button {
    margin-right: 15px;
  }
}
</style>
